import { TABLE_STATE_URL_PARAMS } from "./const";

export const removeEmptyUrlParams = (urlParams: URLSearchParams) => {
  const paramsObject = Object.fromEntries(urlParams);
  for (const key of Object.keys(paramsObject)) {
    if (paramsObject[key] === "" && !TABLE_STATE_URL_PARAMS.includes(key)) {
      delete paramsObject[key];
    }
  }
};
